/********************
 * UTILITIES + TESTS *
 ********************/
// Norsk språk og NOK som valuta
const LOCALE = "nb-NO";
const CURRENCY = "NOK";
// Demo FX fra USD → NOK (erstatt med live-kurs senere ved behov)
const USD_TO_NOK = 11.0;

export function money(amount: number | string) {
  try {
    return new Intl.NumberFormat(LOCALE, {
      style: "currency",
      currency: CURRENCY,
      maximumFractionDigits: 0,
    }).format(Math.round(Number(amount)));
  } catch (e) {
    return `kr ${Math.round(Number(amount)).toLocaleString("nb-NO")}`;
  }
}

export function usdToLocalLabel(usdLabel: string, rate = USD_TO_NOK) {
  const match = typeof usdLabel === "string" && usdLabel.match(/\$(\d+(?:\.\d+)?)\/min/);
  if (!match) {
    const match = usdLabel.match(/\$(\d+(?:\.\d+)?)\/min/);
    if (!match) return `${money(usdLabel)}/min`;
    else return String(usdLabel);
  }

  const usd = parseFloat(match[1]);
  const nok = Math.round(usd * rate);
  return `${money(nok)}/min`;
}

// Behold INR-hjelper for bakoverkomp.
export function inr(amount: number | string) {
  const n = Number(amount);
  if (Number.isNaN(n)) return amount;
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
}

export function readingLine(count: number, sinceYear: number) {
  const n = count.toLocaleString("nb-NO");
  return `${n} lesninger siden ${sinceYear}`;
}

// --- Test cases (små og ikke-blokkerende) ---
try {
  console.assert(usdToLocalLabel("$1.00/min", 10).endsWith("/min"), "TC NOK convert basic");
  console.assert(usdToLocalLabel("$5.99/min").includes("kr"), "TC NOK contains kr");
  console.assert(usdToLocalLabel("249 kr/min") === "249 kr/min", "TC passthrough non-USD");
  console.assert(typeof money(149) === "string", "TC money string");
} catch (e) {
  console.warn("tests warning:", e);
}